import { breakpointSizes, getBreakpointDown } from '@paywithextend/components'
import { base_colorContentBorder } from 'ext-ui/style/colors'
import { css } from 'styled-components'

export default css`
  display: grid;
  grid-template-columns: 40% 60%;

  // border on CMS content between CMS content and signup content
  & > *:first-child {
    border: none;
    border-right: 1px solid ${base_colorContentBorder};
  }

  // Hide the CMS on smaller screens
  @media (max-width: 768px) {
    grid-template-columns: 1fr;

    & > *:first-child {
      display: none;
    }
  }
`

export const mobilePopupStyle = css`
  display: none;
  ${getBreakpointDown(breakpointSizes.XSM)(css`
    display: block;
  `)}
`
